import { service } from '@ember/service'
import type { IntlService } from 'ember-intl'
import { RolloverStep } from 'teacher-ui-client/school-rollover/steps'
import StepRoute from '../step-route'

export default class TeachersRoute extends StepRoute {
  @service
  intl!: IntlService

  /**
   * @property stepId used by {StepRoute} to save the furthest step visited.
   */
  stepId = RolloverStep.Teachers

  buildRouteInfoMetadata() {
    let title = this.intl.t('manage.rollover.title')
    if (this.intl.exists(`manage.rollover.steps.${this.stepId}.title`)) {
      title = this.intl.t(`manage.rollover.steps.${this.stepId}.title`)
    }
    return { stepId: this.stepId, title }
  }
}
